import Dropdown from "../Dropdown";
import { data } from "../../../shared/state/payload";
import { langId } from "@escapio/shared/l10n/lang-id";
import { pageType } from "@escapio/portal/state/pageType";
import { track } from "../../tracker/EventTracker";

class DropdownLanguages extends Dropdown {
	constructor() {
		super();

		this.classList.add("esc-dropdown-menu");

		for (let lang in data.languageNavigation) {
			this.addOption(lang, lang, lang, langId == lang);
		}
	}

	toggle(event) {
		super.toggle(event);
		track(
			"Header",
			"Sprache Dropdown",
			`${this.isOpen() ? "öffnen" : "schließen"} - ${pageType}`,
		);
	}

	setValue(value) {
		window.location = data.languageNavigation[value].uri;
		super.setValue(value);
	}
}
customElements.define("esc-dropdown-languages", DropdownLanguages);
